function HeroDescription({ children }) {
    return <p className="text-lg font-medium text-black">{children}</p>
}

export default HeroDescription
